import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiPost } from "@/api/client";
import { qk } from "@/api/keys";
import type {
  SrsAnswerResponse,
  SrsCompleteResponse,
  SrsSessionStartResponse,
} from "@/api/mutations/srs";

export function useStartWeaknessSessionMutation() {
  return useMutation({
    mutationFn: (vars: { group_key: string }) =>
      apiPost<SrsSessionStartResponse>("me/weakness-sessions", vars),
  });
}

export function useAnswerWeaknessSessionMutation(sessionId: string) {
  return useMutation({
    mutationFn: (vars: { question_id: string; user_answer: string }) =>
      apiPost<SrsAnswerResponse>(
        `me/weakness-sessions/${sessionId}/answer`,
        vars,
      ),
  });
}

export function useCompleteWeaknessSessionMutation(sessionId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const resp = await apiPost<SrsCompleteResponse>(
        `me/weakness-sessions/${sessionId}/complete`,
        {},
      );
      qc.invalidateQueries({ queryKey: qk.stats() });
      qc.invalidateQueries({ queryKey: qk.weaknesses() });
      qc.invalidateQueries({ queryKey: qk.srsDue() });
      qc.invalidateQueries({ queryKey: qk.coachToday() });
      return resp;
    },
  });
}
